import createStyles from '@mui/styles/createStyles';

export default createStyles({
    styleOverrides: {
        root: {
            maxWidth: 'unset',
            minWidth: 'min-content',
        },
    },
});
